import {Box, Stack} from "@mui/material"
import React, {useCallback} from "react"
import Content from "../../components/Content"
import {doNothing} from "../../misc/utils"

export const containerStyledBoxPrototype = [
    {
        key: "backgroundColor",
        type: "COLOR",
        label: "Hintergrundfarbe",
        size: 3,
    },
    {
        key: "paddingX",
        type: "INTEGER",
        label: "Padding X",
        size: 3,
    },
    {
        key: "paddingY",
        type: "INTEGER",
        label: "Padding Y",
        size: 3,
    },
    {
        key: "borderRadius",
        type: "INTEGER",
        label: "Border Radius",
        size: 3,
    },
    {
        key: "isSelected",
        type: "YESNO",
        label: "Selected",
        defaultValue: false,
        size: 3,
    },
]

const ContainerStyledBox = ({container, disabled, value, triggerAction, getDataFromPointer, payload}) => {
    const {children, backgroundColor, paddingX, paddingY, borderRadius, selectedPointer} =
        container
    const padding = {
        paddingTop: `${paddingY}px` ?? "0px",
        paddingBottom: `${paddingY}px` ?? "0px",
        paddingLeft: `${paddingX}px` ?? "0px",
        paddingRight: `${paddingX}px` ?? "0px",
    }
    const bgColor = backgroundColor ? {backgroundColor} : {}

    //hierfür muss ein konzept durchdacht werden, würde grundlegend vorschlagen es im contaienr über eine active prop zu steuern und isSelected ins interface aufzunehmen
    const isSelected = container?.isSelected ?? value?.label === payload?.label

    const stylings = {
        ...padding,
        ...bgColor,
        borderRadius: borderRadius ? `${borderRadius}px` : "0px",
        cursor: container?.action ? "pointer" : "default",
    }

    const onClick = useCallback(
        () => container?.action && triggerAction(container?.action, value),
        [triggerAction, container, value],
    )

    return (
        <Box
            onClick={container?.action ? onClick : doNothing}
            sx={(theme) => ({
                ...stylings,
                border: isSelected
                    ? `1px solid ${theme.STYLEDBOX.selectedBorderColor}`
                    : "1px solid transparent",
            })}
            height={"100%"}
            className={disabled ? "disabled" : ""}>
            <Stack spacing={3}>
                {children.map((child) => (
                    <Content
                        key={container.id}
                        child={child}
                        payload={payload}
                    />
                ))}
            </Stack>
        </Box>
    )
}

export default ContainerStyledBox
